module.exports = __webpack_public_path__ + "static/Truck20-669402b26ed4c5f869fc1d71c6def1d4.png";